import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { pubState } from "../../../../../../recoil/pub.atom";
import { useControllerContext } from "../../../../hooks/controller-context";
import {
  addOnTournament,
  EntryType,
  reBuyInTournament,
  TournamentParticipantPaymentRequest,
} from "../../../../../../api/tournament-participant";
import {
  ControllerParticipationContent,
  ControllerParticipationUserPoint,
  ControllerParticipationUserWrapper,
  ControllerParticipationWrapper,
} from "./style";
import { Const } from "../../../../../../common/const/const";
import { WideState } from "../../../../../../recoil/wide";
import { useParticipantContext } from "../../../sit-in/hooks/participant-context";
import { usePaymentTypes } from "../../../sit-in/hooks/usePaymentTypes";
import { getPubMemberList } from "../../../../../../api/member";
import { PaymentTypeInput } from "../../../sit-in/components/payment-input";
import { ControllerSitInButtonGroup } from "../../../sit-in/style";
import { useParams } from "react-router-dom";
import { exchangePoint } from "../../../../../../utils/number";
import { isTournamentAccess } from "../../../../../../utils/owner";

export const MobileControllerReEntry = () => {
  const {
    selectedMember,
    reloadData,
    isReEntryType,
    isCount,
    setIsReEntryPopup,
    reEntryType,
  } = useParticipantContext();
  const { data, level } = useControllerContext();
  const { payType } = usePaymentTypes();
  const { id } = useParams();
  const tournamentId = id?.replace(/[^0-9]/g, "");
  const isAddOn = isReEntryType(EntryType.ADD_ON);
  const isWide = useRecoilValue(WideState);
  // 지불할 포인트, 시드, 총 결제 금액
  const [payPoint, setPayPoint] = useState<number>(0);
  const [paySeed, setPaySeed] = useState<number>(0);
  const [totalPay, setTotalPay] = useState<number>(0);
  // 추가 스택
  const [addStack, setAddStack] = useState(0);
  // 연속 클릭 방지
  const [isUpdate, setIsUpdate] = useState<boolean>(false);
  // 멤버 포인트
  const [point, setPoint] = useState<number>(0);
  const [seed, setSeed] = useState<number>(0);
  const pub = useRecoilValue(pubState);

  // 포인트, 시드 값 조회
  const getMemberPoint = async () => {
    if (!selectedMember || !pub) return;

    try {
      const res = await getPubMemberList(selectedMember.nickname, pub.id);
      const member = res.memberList.find(
        (item) => item.memberId === selectedMember.memberId,
      );
      setPoint(member?.point || 0);
      setSeed(member?.seed || 0);
    } catch (e: any) {
      alert(e.message);
      return;
    }
  };

  useEffect(() => {
    getMemberPoint();
  }, []);

  useEffect(() => {
    if (!data?.addOn || !data.reBuyIn) return;
    const pay = isAddOn ? data?.addOn : data?.reBuyIn;
    setTotalPay(pay);
  }, [data]);

  // 리엔트리 / 애드온 업데이트
  const handleReEntry = async (
    reqPayType?: TournamentParticipantPaymentRequest[],
  ) => {
    if (isUpdate) return;
    if (!selectedMember || !tournamentId || !pub) return;
    if (!isTournamentAccess(+tournamentId, pub?.tournamentIds)) {
      alert(`토너먼트 ID ${tournamentId}에 대한 권한이 없습니다. `);
      return;
    }

    // 결제 정보 request 변환
    const paymentRequest: TournamentParticipantPaymentRequest[] =
      reqPayType || [];
    if (paymentRequest.length === 0) {
      for (const type of payType) {
        if (type.value === 0 || type.value === null) continue;
        paymentRequest.push({
          paymentMethod: type.type,
          paymentAmount: type.value,
        });
      }
    }
    const sum = paymentRequest.reduce((a, b) => a + b.paymentAmount, 0);

    if (sum <= 0) {
      alert("총 결제 금액은 0보다 커야합니다. ");
      return;
    }

    // 결제 가능 여부
    if (!checkRegisterInput(isAddOn ? data?.addOn : data?.reBuyIn, sum)) return;

    const payment = {
      memberId: selectedMember.memberId,
      pubId: pub.id,
      tournamentId: +tournamentId,
      level: +level === 0 ? 1 : level,
      entryType: reEntryType,
      paymentMethodRequests: paymentRequest,
      description: "",
      addStack: addStack,
    };

    const req = {
      requests: [payment],
      memberId: selectedMember.memberId,
      isCount: isAddOn ? isCount : false,
    };

    try {
      setIsUpdate(true);
      isAddOn ? await addOnTournament(req) : await reBuyInTournament(req);
      reloadData();
      alert("저장되었습니다. ");
      setIsReEntryPopup(false);
    } catch (e: any) {
      if (e.status === 403) {
        alert(e.response.data.message);
        return;
      }
      alert(e.message);
    }
  };

  // 결제 금액 확인
  const checkRegisterInput = (value: number | undefined, sum: number) => {
    if (!value) return;
    if (value !== sum) {
      alert(`결제 금액을 확인해주세요.`);
      return false;
    }

    if (payPoint < 0) {
      if (point && point > 0) {
        alert(`회원의 매장이용권가 부족합니다. `);
        return false;
      }
    }
    if (paySeed < 0) {
      if (seed && seed > 0) {
        alert(`회원의 크레딧이 부족합니다. `);
        return false;
      }
    }
    return true;
  };

  const userPoints = [
    {
      name: isWide ? `보유 매장 이용권` : "보유 E",
      value: +exchangePoint(point),
      pay: +exchangePoint(payPoint),
      unit: "E",
    },
    {
      name: isWide ? "보유 크레딧" : "보유 RB",
      value: seed ?? 0,
      pay: paySeed,
      unit: "RABBIT",
    },
  ];

  const checkPay = () => {
    if (totalPay === 0) {
      if (userPoints.some((p) => p.value - p.pay < 0)) return false;
      return true;
    }
    return false;
  };

  const handlePayFull = (index: number) => {
    if (!data) return;
    const buyIn = isAddOn ? data?.addOn : data?.reBuyIn;
    if (!buyIn) return;

    payType.forEach((item, i) => {
      const isTarget = i === index;
      const valueToSet = isTarget ? buyIn : 0;

      item.set(valueToSet);

      if (item.unit === "E" && setPayPoint) {
        setPayPoint(valueToSet);
      } else if (item.unit === "RABBIT" && setPaySeed) {
        setPaySeed(isTarget ? buyIn / Const.SEED_RATE : 0);
      }
    });

    const paymentRequest: TournamentParticipantPaymentRequest[] = [];
    payType.forEach((item, i) => {
      const isTarget = i === index;
      const valueToSet = isTarget ? buyIn : 0;

      if (valueToSet === 0) return;
      paymentRequest.push({
        paymentMethod: item.type,
        paymentAmount: valueToSet,
      });
    });

    handleReEntry(paymentRequest);
  };

  return (
    <ControllerParticipationWrapper isSearch={true} isWide={isWide}>
      <div className="title">{isAddOn ? "애드온" : "리엔트리"}</div>
      <ControllerParticipationContent>
        {/* 유저 정보 */}
        <ControllerParticipationUserWrapper>
          <div className="name">{selectedMember?.nickname}</div>
          <ControllerParticipationUserPoint>
            {userPoints.map((item, i) => (
              <div className="point" key={i}>
                <div className="name">{item.name}</div>
                <div className="value">
                  {(item?.value - item.pay)?.toLocaleString()} {item.unit}
                </div>
              </div>
            ))}
          </ControllerParticipationUserPoint>
        </ControllerParticipationUserWrapper>
        {/* 결제 input */}
        <PaymentTypeInput
          payType={payType}
          setTotalPay={setTotalPay}
          buyIn={isAddOn ? data?.addOn : data?.reBuyIn}
          setPayPoint={setPayPoint}
          setPaySeed={setPaySeed}
          totalPay={totalPay}
          addStack={addStack}
          setAddStack={setAddStack}
          handlePayFull={handlePayFull}
        />
      </ControllerParticipationContent>
      <ControllerSitInButtonGroup>
        <div
          className={`button ${checkPay() ? "purple" : "gray"}`}
          onClick={() => !isUpdate && handleReEntry()}
        >
          저장
        </div>
        <div
          className="button"
          onClick={() => {
            setIsReEntryPopup(false);
          }}
        >
          취소
        </div>
      </ControllerSitInButtonGroup>
    </ControllerParticipationWrapper>
  );
};
